import PlayIcon from "../images/PlayIcon.mjs";

/**
 * Simulation status: running
 * @see {GlyphIcon}
 * @see {PlayIcon}
 */
const AppSimStatusRunningIcon = class extends PlayIcon {};

export default AppSimStatusRunningIcon;